<template>
    <modal
        @closed="closeHolidayModal"
        :allowCancel="false">
        <div
            class="holiday-modal"
            v-if="!showHolidayBoxForm">
            <h2 v-if="hasDelivery" class="holiday-modal--skip">{{ $t('HOLIDAY_BOX_LIKE_TO_SKIP') }}</h2>
            <h2 v-if="hasHolidayBox" class="holiday-modal--skip">{{ $t('HOLIDAY_BOX_CANCEL_GIFT') }}</h2>
            <div class="holiday-modal--date">
                <div class="holiday-modal--date--container">
                    <div v-text="displayDate.name" class="holiday-modal--date--container--day"></div>
                    <div v-text="displayDate.day" class="holiday-modal--date--container--date"></div>
                    <div v-text="displayDate.month" class="holiday-modal--date--container--month"></div>
                </div>
            </div>
            <div>
                <p>{{$t('HOLIDAY_BOX_OR')}}</p>
                <h2 v-if="hasDelivery" class="holiday-modal--delivery-head">{{ $t('HOLIDAY_BOX_SEND_TO_FRIEND') }}</h2>
                <p v-if="hasDelivery" class="holiday-modal--delivery-text">{{ $t('HOLIDAY_BOX_KNOW_SOMEONE') }}</p>
                <h2 v-if="hasHolidayBox" class="holiday-modal--delivery-head">{{ $t('HOLIDAY_BOX_RECIEVE_FLOWERS') }}</h2>
                <p v-if="hasDelivery" class="holiday-modal--delivery-text">{{ $t('HOLIDAY_BOX_ENTER_DETAILS') }}</p>
            </div>
        </div>
        <div
            class="holiday-box-form"
            v-if="showHolidayBoxForm">
            <h3>{{ $t('HOLIDAY_BOX_DELIVERY_ADDRESS_DETAILS') }}</h3>
            <p class="holiday-box-form--warning">{{ $t('HOLIDAY_BOX_WARNING') }}</p>
            <hr class="divider">
            <div v-if="!showAddressSelectionOption" class="selected-address">
                <span v-html="`${this.selectedGiftingAddress.first_name} ${this.selectedGiftingAddress.last_name}`"></span><br/>
                <span v-text="selectedGiftingAddress.address1"></span><br/>
                <span v-text="selectedGiftingAddress.city"></span><br/>
                <div class="selected-address--changeAddress">
                    <span v-text="selectedGiftingAddress.postcode"></span>
                    <p v-text="$t('HOLIDAY_BOX_CHANGE_ADDRESS')"
                        @click="showAddressSelectionOption = true"></p>
                </div>
            </div>
            <gifting-addresses-table :fromHolidayBoxModal="true" v-if="showAddressSelectionOption" @addressSelected="onAddressSelected"/>
            <div class="clear--sm"/>
            <h3 v-if="selectedGiftingAddress">{{ $t('HOLIDAY_BOX_MESSAGE_FOR', {name: selectedGiftingAddress.first_name}) }}</h3>
            <gift-card-message
                v-if="selectedGiftingAddress"
                :forceClean="true"
                defaultMessageBody="HOLIDAY_BOX_DEFAULT_MESSAGE"/>
            <div class="clear--sm"/>
            <h3  v-if="selectedGiftingAddress">{{ $t('HOLIDAY_BOX_NOTIFICATION_DETAILS') }}</h3>
            <delivery-notification :fromHolidayBoxModal="true" v-if="selectedGiftingAddress"/>
        </div>
        <button
            slot="actions-prefix"
            class="btn btn--secondary holiday-modal--action"
            :disabled="isProcessingSkipButton || isProcessing"
            v-if="!showHolidayBoxForm && hasDelivery"
            @click="onSkipThisDelivery(false)">{{ skipButtonText }}</button>
        <button
            slot="actions-suffix"
            :disabled="isProcessingSkipButton"
            v-if="!showHolidayBoxForm && hasDelivery"
            @click="showHolidayBoxForm = true"
            class="btn btn--primary holiday-modal--action">{{ $t('HOLIDAY_BOX_I_WILL_SEND_TO_FRIEND') }}</button>
        <button
            slot="actions-suffix"
            :disabled="isProcessing || !selectedGiftingAddress"
            v-if="showHolidayBoxForm"
            @click="onSkipThisDelivery(true)"
            class="btn btn--primary holiday-modal--action">{{ sendBoxButtonText }}</button>
        <button
            slot="actions-prefix"
            class="btn btn--secondary holiday-modal--action"
            :disabled="isProcessingSkipButton || isProcessing"
            v-if="hasHolidayBox"
            @click="cancelGiftAndSkip">{{ cancelGiftButtonText }}</button>
        <button
            slot="actions-suffix"
            :disabled="isProcessing || isProcessingSkipButton"
            v-if="hasHolidayBox"
            @click="cancelGiftAndSendToMe"
            class="btn btn--primary holiday-modal--action">{{ sendToMeButtonText }}</button>
    </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    formatDate,
} from '@/helpers/DateHelpers';
import * as Dates from '@/constants/Dates';
import Modal from '@/components/structure/Modal';
import ScheduledOrderService from '@/services/subscriptions/Subscriptions/ScheduledOrderService';
import GiftingAddressesTable from '@/components/partials/account/gifting/deliveryAddress/GiftingAddressesTable';
import DeliveryNotification from '@/components/partials/account/gifting/DeliveryNotification';
import GiftCardMessage from '@/components/partials/account/gifting/GiftCardMessage';

let scheduledOrderService = new ScheduledOrderService();
export default {
    name: 'HolidayBoxModal',
    components: {
        Modal,
        GiftingAddressesTable,
        DeliveryNotification,
        GiftCardMessage,
    },
    data() {
        return {
            isProcessingSkipButton: false,
            isProcessing: false,
            showHolidayBoxForm: false,
            showAddressSelectionOption: !this.selectedGiftingAddress,
        };
    },
    computed: {
        ...mapGetters({
            selectedDelivery: 'scheduledOrder/getSelectedDelivery',
            subscription: 'subscription/getActiveSubscription',
            selectedGiftingAddress: 'address/getSelectedGiftingAddress',
            body: 'gifting/getMessageBody',
            from: 'gifting/getMessageFrom',
            to: 'gifting/getMessageTo',
            notifierNumber: 'gifting/getNotifierNumber',
        }),
        skipButtonText() {
            return this.isProcessingSkipButton ? this.$t('SUBMIT_BUTTON_PLEASE_WAIT') : this.$t('HOLIDAY_BOX_NO_THANKS_SKIP');
        },
        sendBoxButtonText() {
            return this.isProcessing ? this.$t('SUBMIT_BUTTON_PLEASE_WAIT') : this.$t('HOLIDAY_BOX_SEND_THIS_BOX');
        },
        sendToMeButtonText() {
            return this.isProcessing ? this.$t('SUBMIT_BUTTON_PLEASE_WAIT') : this.$t('HOLIDAY_BOX_SEND_TO_ME');
        },
        cancelGiftButtonText() {
            return this.isProcessingSkipButton ? this.$t('SUBMIT_BUTTON_PLEASE_WAIT') : this.$t('HOLIDAY_BOX_CANCEL_GIFT_AND_SKIP');
        },
        hasHolidayBox() {
            return this.selectedDelivery.delivery_scheduled && (typeof this.selectedDelivery?.holiday_box_id !== 'undefined');
        },
        hasDelivery() {
            return this.selectedDelivery.delivery_scheduled && !(typeof this.selectedDelivery?.holiday_box_id !== 'undefined');
        },
        displayDate() {
            const name = formatDate(this.selectedDelivery.datetime, Dates.SHORT_DAY);
            const day = formatDate(this.selectedDelivery.datetime, Dates.SINGLE_NUMBER_DAY);
            const month = formatDate(this.selectedDelivery.datetime, Dates.SHORT_MONTH);
            return {
                name,
                day,
                month,
            };
        },
    },
    methods: {
        cancelGiftAndSkip() {
            this.isProcessingSkipButton = true;
            scheduledOrderService.cancelHolidayBox({
                holiday_box_id: this.selectedDelivery.holiday_id,
            }).then(() => {
                this.isProcessingSkipButton = false;
                this.$store.commit('gifting/setShowHolidayBoxModal', false);
                this.$emit('holiday-button-clicked');
                this.refreshDeliveries();
                this.refreshShopOrderSummary();
            });
        },
        cancelGiftAndSendToMe() {
            this.isProcessing = true;
            scheduledOrderService.cancelHoliday({
                subscriptionId: this.subscription.id,
                holidayId: this.selectedDelivery.holiday_id,
            }).then(() => {
                this.$store.commit('gifting/setShowHolidayBoxModal', false);
                this.isProcessing = false;
                this.$emit('holiday-button-clicked');
                this.$emit('has-recently-skipped-delivery');
                this.refreshDeliveries();
                this.refreshShopOrderSummary();
            });
        },
        closeHolidayModal() {
            this.$store.commit('gifting/setShowHolidayBoxModal', false);
            this.showHolidayBoxForm = false;
        },
        skipThisDelivery(payload) {
            this.isProcessingSkipButton = true;
            scheduledOrderService.createHoliday(payload).then(() => {
                this.isProcessingSkipButton = false;
                this.isProcessing = false;
                this.$store.commit('gifting/setShowHolidayBoxModal', false);
                this.$emit('holiday-button-clicked');
                this.$emit('has-recently-skipped-delivery');
                this.refreshDeliveries();
                this.refreshShopOrderSummary();
            });
        },
        refreshDeliveries() {
            this.$store.dispatch('scheduledOrder/fetchAllDeliveries', true);
        },
        refreshShopOrderSummary() {
            this.$store.dispatch('shop/fetchOrderSummary', true);
            this.$store.dispatch('shop/getNextDeliveryDate', true);
        },
        onAddressSelected() {
            this.showAddressSelectionOption = false;
            if (this.to) this.$store.commit('gifting/updateMessageTo', `${this.$t('GIFT_CARD_MESSAGE_DEAR')} ${this.selectedGiftingAddress.first_name}`);
        },
        onSkipThisDelivery(isHolidayBoxOpted) {
            let payload = {
                subscriptionId: this.subscription.id,
                deliveryDate: this.selectedDelivery.datetime,
                hasHolidayBox: isHolidayBoxOpted,
            };
            if (isHolidayBoxOpted) {
                this.isProcessing = true;
                payload.gifting_address_id = this.selectedGiftingAddress.id;
                payload.message_body = this.body || `${this.$t('HOLIDAY_BOX_DEFAULT_MESSAGE')}`;
                payload.message_from = this.from || `${this.$t('GIFT_CARD_MESSAGE_LOVE')} ${this.$store.getters['account/getFirstName']}`;
                payload.message_to = this.to || `${this.$t('GIFT_CARD_MESSAGE_DEAR')} ${this.selectedGiftingAddress.first_name}`;
                payload.mobile_number = this.notifierNumber;
            }
            this.skipThisDelivery(payload);
        },
    },
};
</script>

<style lang="scss" scoped>
.holiday-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #1a1a1a;
    &--skip {
        font-size: 20px;
    }
    &--delivery-text {
        font-weight: 200;
    }
    &--delivery-head {
        font-size: 25px;
    }
    &--action {
        margin: 10px;
    }
    &--date {
        width: 10%;
        min-width: 40px;
        margin: 20px 0;
        @media (min-width: 640px) {
            font-size: 1rem;
            line-height: 1.5rem;
        }
        &--container {
            text-align: center;
            font-weight: lighter;
            text-transform: uppercase;
            padding-top: 0.75rem;
            padding-bottom: 0.5rem;
            line-height: 1;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
            &--date {
                font-size: 1.5rem;
                padding: 3px 0;
                @media (min-width: 640px) {
                    line-height: 2.05rem;
                }
                @media (min-width: 768px) {
                    font-size: 1.5rem;
                    margin: -0.25rem;
                }
            }
            &--month, &--day {
                font-size: 0.7rem;
            }
        }
    }
}
.holiday-box-form {
    max-height: 70vh;
    overflow-x: scroll;
    text-align: center;
    &--warning {
        margin-top: 20px;
        font-style: italic;
    }
}
.selected-address {
    text-align: left;
    margin: 30px 10%;
    line-height: 25px;
    &--changeAddress {
        display: flex;
        justify-content: space-between;
        p {
            text-decoration: underline;
            cursor: pointer;
            font-weight: 400;
            font-size: 18px;
        }
    }
}
.divider {
    width: 25%;
    margin: 30px auto;
    border: 1px solid #1a1a1a;
}
</style>
